import { ActionIcon } from "@mantine/core";
import PauseRounded from "@mui/icons-material/PauseRounded";
import PlayArrowRounded from "@mui/icons-material/PlayArrowRounded";
import { TestStates } from "@tsTypes/test-schema";

export default function PlayPauseBtn({
  testStatus,
}: {
  testStatus: TestStates;
}) {
  return (
    <ActionIcon
      p={0}
      color={testStatus === "taking" ? "incorrect" : "correct"}
      variant="transparent"
    >
      {["start", "paused"].includes(testStatus) ? (
        <PlayArrowRounded />
      ) : (
        <PauseRounded />
      )}
    </ActionIcon>
  );
}
